import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class Tick extends PureComponent {
  getLabelContent() {
    const { label, color } = this.props
    const style = { color }
    if (label && label.length > 0) {
      return (
        <div style={style} className="label">
          {label}
        </div>
      )
    }
    return null
  }

  render() {
    const { x, size, color } = this.props
    const label = this.getLabelContent()
    const transformString = `translate(${x}px, 0px)`
    const tickStyle = {
      left: 0,
      WebkitTransform: transformString,
      MozTransform: transformString,
      msTransform: transformString,
      transform: transformString,
    }
    const graphicStyle = { backgroundColor: color }
    return (
      <div className={classnames('tick', `tick--${size}`)} style={tickStyle}>
        <div className="tick__content">
          {label}
          <div className="graphic" style={graphicStyle}></div>
        </div>
      </div>
    )
  }
}
Tick.propTypes = {
  x: PropTypes.number.isRequired,
  size: PropTypes.string.isRequired,
  label: PropTypes.string,
  color: PropTypes.string.isRequired,
}
